import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { getAssociationLabel } from '@collections/association-label';
import { CandidateHiringManagerStatusObj } from '@collections/hiring-manager-status';

import { JobConfig, JobPrivileges } from '@modules/job-page/job.abstract.config';
import { Store } from '@ngrx/store';
import { Association, CandidateAdapter, Feedback, Job, AssociationLabel } from '@shared';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { IsMobileViewService } from '@shared/services/is-mobile-view.service';

@Component({
  selector: 'mojo-matched-candidate-buttons',
  templateUrl: './matched-candidate-buttons.component.html',
  styleUrls: ['./matched-candidate-buttons.component.scss'],
})
export class MatchedCandidateButtonsComponent {
  @Input() candidate: CandidateAdapter;
  @Input() showButtonsAlways = false;
  @Input() job: Job;
  @Input() association: Association;
  @Input() cardHover = false;
  @Input() candidateCardActive = false;
  @Input() feedback: Feedback;
  @Input() totalThumbsUp: number;
  @Input() disableFeedback: boolean;
  @Output() feedbackPanelOpened = new EventEmitter<boolean>();

  privileges: JobPrivileges;
  isMobileView$ = this.isMobileService.isMobileView$();

  constructor(
    private jobConfig: JobConfig,
    private store: Store,
    private isMobileService: IsMobileViewService,
  ) {
    this.privileges = this.jobConfig.privileges;
  }
}
